import HabitPackActions from 'dashboard/habit-pack-details/HabitPackActions';
import InquiryNoticeModal from 'dashboard/inquiry/InquiryNoticeModal';
import { useEffect, useMemo } from 'react';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { setCurrentViewedPack } from 'store/reducer//habit-pack/slice';
import HabitPackActivityList from 'pages/marketplace/HabitPackActivityList';
import { EMPTY_LIST, PLATFORMS } from 'constants/general';
import { PAGES } from 'constants/routes';
import DetailsPageWrapper from 'dashboard/wrappers/DetailsPageWrapper';
import DetailsPageHeader from 'dashboard/marketplace/DetailsPageHeader';
import DetailsPageBodyWrapper from 'dashboard/wrappers/DetailsPageBodyWrapper';
import DetailsPageListWrapper from 'dashboard/wrappers/DetailsPageListWrapper';
import Banner from 'components/common/Banner';
import { ATTRIB } from 'constants/test';
import { packDetailsSelector } from 'store/reducer/habit-pack/selectors';

export default function PackDetails() {
  const dispatch = useAppDispatch();
  const {
    currentViewedPack,
    installedHabitPacks,
    platform,
    isInquiryModalShown
  } = useAppSelectorShallow(packDetailsSelector);

  useEffect(() => {
    return () => {
      dispatch(setCurrentViewedPack(null));
    };
  }, [dispatch]);

  const [isFocusOnlyHabitPack, showBanner] = useMemo(
    () => [
      [
        ...(currentViewedPack?.morning_activities ?? []),
        ...(currentViewedPack?.break_activities ?? []),
        ...(currentViewedPack?.evening_activities ?? [])
      ].length === EMPTY_LIST,
      installedHabitPacks.some((pack) => pack.id === currentViewedPack?.id)
    ],
    [currentViewedPack, installedHabitPacks]
  );

  return (
    <DetailsPageWrapper page={PAGES.HABIT_PACK}>
      <Banner
        message={t('banner_message.this_pack_is_ready_to_user')}
        contentWrapperStyles='w-fit px-5 py-2'
        wrapperStyles='self-center'
        defaultValue={showBanner}
      />
      <DetailsPageHeader />
      <DetailsPageBodyWrapper>
        <HabitPackActions />
        <DetailsPageListWrapper
          styles='h-fit ~px-0/4'
          data-testid={ATTRIB.DATA_TESTID.PACK_DETAILS_LIST_WRAPPER}>
          {isFocusOnlyHabitPack ? (
            <p className='m-auto ~sm:~py-12/20 ~text-sm/lg dark:text-secondary-dark-900'>
              {t('market.focus_mode_pack_notice')}
            </p>
          ) : (
            <>
              {(currentViewedPack?.morning_activities ?? []).length ? (
                <HabitPackActivityList
                  allowAddToRoutine
                  category='morning'
                  title={t('market.morning_habits')}
                  habitActivities={currentViewedPack?.morning_activities ?? []}
                />
              ) : null}

              {(currentViewedPack?.evening_activities ?? []).length ? (
                <HabitPackActivityList
                  allowAddToRoutine
                  category='evening'
                  title={t('market.evening_habits')}
                  habitActivities={currentViewedPack?.evening_activities ?? []}
                />
              ) : null}

              {(currentViewedPack?.break_activities ?? []).length ? (
                <HabitPackActivityList
                  allowAddToRoutine
                  category='break'
                  title={t('market.break_activities')}
                  habitActivities={currentViewedPack?.break_activities ?? []}
                />
              ) : null}
            </>
          )}

          {(currentViewedPack?.standalone_activities ?? []).length ? (
            <HabitPackActivityList
              allowAddToRoutine
              category='standalone'
              title={t('market.standalone_activities')}
              habitActivities={currentViewedPack?.standalone_activities ?? []}
            />
          ) : null}
        </DetailsPageListWrapper>
      </DetailsPageBodyWrapper>
      {isInquiryModalShown && platform === PLATFORMS.WEB && (
        <InquiryNoticeModal />
      )}
    </DetailsPageWrapper>
  );
}
